import React from 'react';

import classNames from 'classnames';

import {Button, IButtonProps} from '../../components/button';
import {Grid, GridColumn} from '../../components';


export interface StartScreenProps {
    actions: IButtonProps[]
    title: string;
    className?: string;
}

const StartScreen = (props: StartScreenProps): JSX.Element => {
    const className: string = classNames(
        'startscreen',
        props.className,
    );

    return (
        <form className={className}>
            <div className="text text-center text--triple">
                <h1 className="h2">{props.title}</h1>
                <div className="text">
                    <Grid wrap={['xs']} justify={['between-xs']}>
                        {props.actions.map((action: IButtonProps, i: number) => (
                            <GridColumn key={i} width={['xs-12', 'sm-6']} className={'button__inner startscreen__button'}>
                                <Button {...action}/>
                            </GridColumn>
                        ))}
                    </Grid>
                </div>
            </div>
        </form>
    );
};


export default StartScreen;
